import {useEffect, useState} from 'react';

import {isNil} from 'ramda';
import {isNumber} from 'ramda-adjunct';

import {usePrevious} from 'shared/web';

import {getFormattedSourceSearchParams} from '../utils/url/getFormattedSourceSearchParams';
import {useHttpCalls} from './useHttpCalls';

export function useCountByQueryId() {
  const sourceParams = getFormattedSourceSearchParams();
  const http = useHttpCalls({gridCode: sourceParams.gridCode});
  const [count, setCount] = useState<number | null>(null);

  const prevValue = usePrevious(sourceParams);

  useEffect(() => {
    if (JSON.stringify(sourceParams) === JSON.stringify(prevValue)) {
      return;
    }

    if (isNil(sourceParams.gridCode) || isNil(sourceParams.queryId)) {
      return;
    }

    http.getCountByQuery(sourceParams.queryId).then((rowCountResponse) => {
      isNumber(rowCountResponse) && setCount(rowCountResponse);
    });
  }, [sourceParams.gridCode, sourceParams.queryId]);

  return {
    count,
    hasSourceParams: Boolean(sourceParams.gridCode && sourceParams.queryId),
  };
}
